import { render, staticRenderFns } from "./H5Input.vue?vue&type=template&id=3551f880&scoped=true&"
import script from "./H5Input.vue?vue&type=script&lang=js&"
export * from "./H5Input.vue?vue&type=script&lang=js&"
import style0 from "./H5Input.vue?vue&type=style&index=0&id=3551f880&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3551f880",
  null
  
)

export default component.exports